import wixSite from 'wix-site';
import {filterProducts, sortProducts, filterPageByChoice} from 'public/productsListRepeater.js'; 
import {runProgressBar} from 'public/selectedPageHeader.js'; 
import {session} from 'wix-storage';

$w.onReady(function () 
{	
    $w('#pageNameText').text = wixSite.currentPage.name;
    runProgressBar($w('#pageProgressBar'),1500);  
    filterPageByChoice($w('#dataset1'), "department", session.getItem("filterBy")); 
});


// Filter by Single Customer
export function singleFilterButton_click(event) 
{
    filterProducts($w('#dataset1'),"filterByAmount",1,2);    
    runProgressBar($w('#pageProgressBar'),1500);  
    $w('#singleFilterButton').hide();
    $w('#singleFilterSelectedButton').show();
    $w('#couplesFilterButton').show();
    $w('#couplesFilterSelectedButton').hide()
    $w('#clearFilterButton').show();
}


// Cancel Filter by Single Customer
export function singleFilterSelectedButton_click(event) 
{
    filterProducts($w('#dataset1'),"filterByAmount", 0, 9);
    $w('#singleFilterButton').show();
    $w('#singleFilterSelectedButton').hide();
    $w('#couplesFilterButton').show();
    $w('#couplesFilterSelectedButton').hide()
    $w('#clearFilterButton').hide();
    runProgressBar($w('#pageProgressBar'),1500);  
}


// Filter by Couples
export function couplesFilterButton_click(event) 
{
    filterProducts($w('#dataset1'),"filterByAmount", 2, 3);
    $w('#singleFilterButton').show();
    $w('#singleFilterSelectedButton').hide();
    $w('#couplesFilterButton').hide();
    $w('#couplesFilterSelectedButton').show()
    $w('#clearFilterButton').show();
    runProgressBar($w('#pageProgressBar'),1500);  
}


// Cancel Filter by Couples
export function couplesFilterSelectedButton_click(event) 
{
	filterProducts($w('#dataset1'),"filterByAmount",0,9);
    $w('#singleFilterButton').show();
    $w('#singleFilterSelectedButton').hide();
    $w('#couplesFilterButton').show();
    $w('#couplesFilterSelectedButton').hide()
    $w('#clearFilterButton').hide();
    runProgressBar($w('#pageProgressBar'),1500);  
}


// Clear Product Filters
export function clearFilterButton_click(event) 
{
	filterProducts($w('#dataset1'),"filterByAmount",0,9);
    $w('#singleFilterButton').show();
    $w('#singleFilterSelectedButton').hide();
    $w('#couplesFilterButton').show();
    $w('#couplesFilterSelectedButton').hide()
    $w('#clearFilterButton').hide();
    runProgressBar($w('#pageProgressBar'),1500);      
}


export function sortByPriceUpButton_click(event) 
{
    sortProducts($w('#dataset1'),'ascending','price');
    runProgressBar($w('#pageProgressBar'),1500);  
    $w('#sortByPriceDownSelectedButton').hide();
    $w('#sortByPriceUpButton').hide();
    $w('#sortByPriceDownButton').show();
    $w('#sortByPriceUpSelectedButton').show();
}


export function sortByPriceDownButton_click(event) 
{
    sortProducts($w('#dataset1'),'descending','price');	  
    runProgressBar($w('#pageProgressBar'),1500);
    $w('#sortByPriceDownSelectedButton').show();
    $w('#sortByPriceUpButton').show();
    $w('#sortByPriceDownButton').hide();
    $w('#sortByPriceUpSelectedButton').hide();      
}


export function sortByPriceUpSelectedButton_click(event) 
{
    sortProducts($w('#dataset1'),'descending','price');	  
    runProgressBar($w('#pageProgressBar'),1500);    
    $w('#sortByPriceDownSelectedButton').show();
    $w('#sortByPriceUpButton').show();
    $w('#sortByPriceDownButton').hide();
    $w('#sortByPriceUpSelectedButton').hide();
}


export function sortByPriceDownSelectedButton_click(event) 
{
    sortProducts($w('#dataset1'),'ascending','price');	  
    runProgressBar($w('#pageProgressBar'),1500);    
    $w('#sortByPriceDownSelectedButton').hide();
    $w('#sortByPriceUpButton').hide();
    $w('#sortByPriceDownButton').show();
    $w('#sortByPriceUpSelectedButton').show();
}

